import { render, staticRenderFns } from "./LoginAsNew.vue?vue&type=template&id=518e66a2&scoped=true"
import script from "./LoginAsNew.vue?vue&type=script&lang=js"
export * from "./LoginAsNew.vue?vue&type=script&lang=js"
import style0 from "./LoginAsNew.vue?vue&type=style&index=0&id=518e66a2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518e66a2",
  null
  
)

export default component.exports